import PropuestasExternas from "../../components/PropuestasExternas";

export const ListadoCotizaciones = () => <PropuestasExternas />;
